import { waitDialog } from 'dialogs';
import { recordToEdit } from 'edit/recordToEdit';
import type { CreateTarget } from 'actions';
import { getQueue, type FetchedQueue } from 'api/queues/endpoints/getQueue';
import QueueEditDialog from '../QueueEditDialog';

export type ShowEditQueueArgs = { readonly mode: 'create'; readonly createIn?: CreateTarget } | { readonly mode: 'edit'; readonly id: number };

/**
 * Open the queue create / edit dialog and resolve when it closes (so the caller
 * can refresh). Standalone async: for edit it always fetches the row by id
 * (boundary-validated), so it works from the Workspace — which never populates
 * the list slice — and never opens the dialog on a loosely-cast store row.
 */
export const showEditQueue = async (args: ShowEditQueueArgs): Promise<void> => {
  const createIn = args.mode === 'create' ? args.createIn : undefined;
  let data: FetchedQueue | null = null;
  if (args.mode === 'edit') {
    const record = await recordToEdit('Queue', () => getQueue(args.id));
    if (record === undefined) return;
    data = record;
  }
  await waitDialog<void>((ok) => <QueueEditDialog show handleClose={ok} mode={args.mode} data={data} createIn={createIn} />);
};
